// src/use-api.ts
import createClient from "openapi-react-query";
import { useToast } from "@mezzoforte/forge";
import { useState } from "react";
import Cookies from "js-cookie";
import { createApiClient } from "@mezzoforte/huutokaupat-api-client";
var ClientError = class extends Error {
  response;
  constructor(response) {
    super("ClientError");
    this.response = response;
  }
};
var useApi = () => {
  const { playToast } = useToast();
  const [api] = useState(() => {
    const onErrorMiddleware = {
      onResponse({ response }) {
        if (!response.ok) {
          if (response.status === 503) {
            playToast(
              "Pieni hetki, huollamme sivustoa",
              "Huutokaupat.com on pois k\xE4yt\xF6st\xE4 huoltot\xF6iden takia. Pyrimme saamaan palvelun k\xE4ytt\xF6\xF6n mahdollisimman pian.",
              {
                toastId: "service-unavailable-error",
                variant: "danger",
                closeManually: true
              }
            );
          }
          if (response.status === 429) {
            playToast(
              "Virhe",
              "Liikaa pyynt\xF6j\xE4. Odota hetki ja yrit\xE4 sen j\xE4lkeen uudestaan.",
              {
                toastId: "too-many-requests-error",
                variant: "danger",
                closeManually: true
              }
            );
          }
          throw new ClientError(response);
        }
      }
    };
    const csrfMiddleware = {
      onRequest({ request }) {
        const csrfToken = Cookies.get("csrf-token");
        if (csrfToken !== void 0) {
          request.headers.set("X-Csrf-Token", csrfToken);
        }
        return request;
      }
    };
    const client = createApiClient();
    client.use(csrfMiddleware);
    client.use(onErrorMiddleware);
    return createClient(client);
  });
  return api;
};
export {
  ClientError,
  useApi
};
